// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form_DtHjw {
  min-width: 400px;
  position : relative;
  height : 100%;
}

.content_lc9t5 {
  height : 100%;
}

.area_hOSPb {
  padding : 0 var( --size-padLarge, 16px );
}

.spacer_DoC3E {
  padding-top : var( --size-padLarge, 16px );
}

.footer_V4xSa {
  padding : var( --size-padLarge, 16px );
  display : grid;
  justify-content: center;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  column-gap: var( --size-padMedium, 8px );
}

.delete_VV1Nq {
  justify-self: start;
}

.saveCancel_CtN0t {
  justify-self: end;
  display : grid;
  justify-content: center;
  align-items: stretch;
  grid-template-columns: 1fr 1fr;
  column-gap: var( --size-padMedium, 8px );
}
`, "",{"version":3,"sources":["webpack://./src/screens/clientId/EditModel.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,wCAAwC;AAC1C","sourcesContent":[".form {\n  min-width: 400px;\n  position : relative;\n  height : 100%;\n}\n\n.content {\n  height : 100%;\n}\n\n.area {\n  padding : 0 var( --size-padLarge, 16px );\n}\n\n.spacer {\n  padding-top : var( --size-padLarge, 16px );\n}\n\n.footer {\n  padding : var( --size-padLarge, 16px );\n  display : grid;\n  justify-content: center;\n  align-items: center;\n  grid-template-columns: 1fr 1fr;\n  column-gap: var( --size-padMedium, 8px );\n}\n\n.delete {\n  justify-self: start;\n}\n\n.saveCancel {\n  justify-self: end;\n  display : grid;\n  justify-content: center;\n  align-items: stretch;\n  grid-template-columns: 1fr 1fr;\n  column-gap: var( --size-padMedium, 8px );\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `form_DtHjw`,
	"content": `content_lc9t5`,
	"area": `area_hOSPb`,
	"spacer": `spacer_DoC3E`,
	"footer": `footer_V4xSa`,
	"delete": `delete_VV1Nq`,
	"saveCancel": `saveCancel_CtN0t`
};
export default ___CSS_LOADER_EXPORT___;
